import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { Table } from "../../../components/SystemComponent/table";
import { GroupButton } from "../../../components/SystemComponent/GroupButton";
import { Badge } from "../../../components/SystemComponent/Bagde";
import { MdVisibility, MdPerson, MdBusiness } from "react-icons/md";
import { createApi } from "../../../../core/api";
import { AircraftRequestDetailModal } from "./AircraftRequestDetailModal";

const ConfirmStatusText: any = {
  0: "Pending",
  1: "Approved",
  2: "Rejected",
};

const ConfirmStatusColor: any = {
  0: "#F59E0B",
  1: "#16A34A",
  2: "#DC2626",
};

export const AircraftRequestList = () => {
  const api = useMemo(() => createApi(), []);
  const { setPageMenus } = useOutletContext<any>();

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [detailId, setDetailId] = useState<number | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    const r: any = await api.aircraftRequest.getAll();
    if (r?.ok) setData(r.data?.data ?? []);
    setLoading(false);
  }, [api]);

  useEffect(() => {
    setPageMenus([
      {
        label: "Aircraft Requests",
        items: [
          {
            label: "Aircraft Requests",
            route: "/dashboard/aircraft-request",
          },
        ],
      },
    ]);
    load();
    return () => setPageMenus([]);
  }, [load, setPageMenus]);

  const columns = useMemo<any[]>(
    () => [
      {
        key: "requestDescripton",
        title: "Request",
        minWidth: 220,
        accessor: (r: any) => r.requestDescripton,
        render: (_: any, v: string) => (
          <Badge
            label={v ?? "-"}
            color="#6366F1"
            bg="rgba(99,102,241,.15)"
          />
        ),
      },
      {
        key: "fromCompany",
        title: "From Company",
        accessor: (r: any) => r.fromCompany?.companyName,
        render: (_: any, v: string) =>
          v ? (
            <Badge
              icon={MdBusiness}
              label={v}
              color="#0EA5E9"
              bg="rgba(14,165,233,.15)"
            />
          ) : (
            "-"
          ),
      },
      {
        key: "toCompany",
        title: "To Company",
        accessor: (r: any) => r.toCompany?.companyName,
        render: (_: any, v: string) =>
          v ? (
            <Badge
              icon={MdBusiness}
              label={v}
              color="#16A34A"
              bg="rgba(22,163,74,.15)"
            />
          ) : (
            "-"
          ),
      },
      {
        key: "fromUser",
        title: "From User",
        accessor: (r: any) => r.fromUser ? `${r.fromUser.firstName} ${r.fromUser.lastName}` : null,
        render: (_: any, v: string) =>
          v ? (
            <Badge
              icon={MdPerson}
              label={v}
              color="#2563EB"
              bg="rgba(37,99,235,.15)"
            />
          ) : (
            "-"
          ),
      },
      {
        key: "status",
        title: "Status",
        accessor: (r: any) => r.confirmStatus,
        render: (_: any, v: any) => (
          <Badge
            label={ConfirmStatusText[v]}
            color={ConfirmStatusColor[v]}
            bg={`${ConfirmStatusColor[v]}22`}
          />
        ),
      },
      {
        key: "createdDate",
        title: "Created",
        accessor: (r: any) => r.createdDate,
        render: (_: any, v: string) =>
          v ? new Date(v).toLocaleDateString() : "-",
      },
      {
        key: "actions",
        title: "Actions",
        minWidth: 140,
        render: (r: any) => (
          <GroupButton
            items={[
              {
                key: "detail",
                icon: MdVisibility,
                color: "#2563EB",
                tooltip: "Detail",
                onClick: () => setDetailId(r.id),
              },
            ]}
          />
        ),
      },
    ],
    []
  );

  return (
    <div style={S.wrap}>
      <div style={S.header}>
        <div>
          <div style={S.title}>Aircraft Requests</div>
          <div style={S.subTitle}>Incoming & outgoing aircraft requests</div>
        </div>
      </div>

      <Table
        tableKey="aircraft-request"
        loading={loading}
        columns={columns}
        data={data}
        features={{
          sortable: true,
          filterable: true,
          pagination: true,
          persistence: true,
        }}
      />

      {detailId && (
        <AircraftRequestDetailModal
          id={detailId}
          onClose={() => setDetailId(null)}
        />
      )}
    </div>
  );
};

const S: Record<string, React.CSSProperties> = {
  wrap: {
    position: "absolute",
    inset: 0,
    padding: 20,
    background: "#F8FAFC",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: "#0F172A",
  },
  subTitle: {
    fontSize: 13,
    color: "#64748B",
  },
};
